var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDenimwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 118,
    viewBox: "0 0 141 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "none",
    fill: "#080404",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 3.268 C 0 5.065, 1.061 8.103, 2.357 10.018 C 3.654 11.933, 14.524 29.700, 26.514 49.500 C 38.504 69.300, 52.795 92.813, 58.273 101.750 C 71.606 123.506, 70.380 123.554, 84.066 100.750 C 89.760 91.263, 98.743 76.525, 104.028 68 C 127.186 30.647, 142 5.144, 142 2.632 L 142 0 71 0 L 0 0 0 3.268 M 0.232 4 C 0.232 5.925, 0.438 6.713, 0.689 5.750 C 0.941 4.787, 0.941 3.212, 0.689 2.250 C 0.438 1.288, 0.232 2.075, 0.232 4 M 12 8.443 C 12 8.909, 22.194 25.853, 46.027 65 C 53.895 77.925, 62.574 92.228, 65.313 96.785 C 68.052 101.341, 70.667 104.941, 71.124 104.785 C 71.582 104.628, 78.875 93.025, 87.332 79 C 95.789 64.975, 108.324 44.275, 115.187 33 C 122.051 21.725, 128.207 11.488, 128.868 10.250 L 130.070 8 71.035 8 C 38.566 8, 12 8.200, 12 8.443",
    stroke: "none",
    fill: "#040404",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDenimwear);
export default __webpack_public_path__ + "static/media/black-denimwear.7a001aaae272bc74470cfe774ab4c6ce.svg";
export { ForwardRef as ReactComponent };